export default Object.freeze({
  info: {},
  list: [],
});
